// OTP-R3: внутренний исход устаревшей auth-попытки — не бизнес-ошибка и не
// сообщение пользователю. Вынесен из httpClient, чтобы компоненты могли его
// различать и там, где тесты подменяют httpClient целиком.
export class AuthRequestCancelled extends Error {
  constructor() { super('Stale auth request'); this.name = 'AuthRequestCancelled' }
}

export const assertCurrentAuthRequest = (isCurrent?: () => boolean): void => {
  if (isCurrent && !isCurrent()) throw new AuthRequestCancelled()
}
